import { getFieldDisplayName } from "@helpers/getFieldDisplayName";
import React from "react";
import { useLocation } from "react-router-dom";

type ValidationState = {
  showValidationAlert?: boolean;
  missingFields?: string[];
};

export const useRouteValidationAlert = () => {
  const location = useLocation();
  const state = location.state as ValidationState | undefined;

  const showAlert = state?.showValidationAlert ?? false;
  const missingFields = state?.missingFields ?? [];

  const AlertComponent = () =>
    showAlert && missingFields.length > 0 ? (
      <div className="validation-alert">
        <p>
          Для участия в Нетворкинге, пожалуйста, заполните недостающие данные:
        </p>
        <ul>
          {missingFields.map((field) => (
            <li key={field}>{getFieldDisplayName(field)}</li>
          ))}
        </ul>
      </div>
    ) : null;

  return {
    showAlert,
    missingFields,
    AlertComponent,
  };
};
